import RootState from 'Store/Root';

import { LoadingStatus } from 'Types/Common';

export const siteSelector = (state: RootState): TrykApi.Catalog.ISite => {
  return state.site.item;
};

export const loadingStatusSelector = (state: RootState): LoadingStatus => {
  return {
    loading: state.site.loading,
    loaded: state.site.loaded,
    failed: state.site.failed
  };
};

export const brandNameMapSelector = (state: RootState): _.Dictionary<string> => {
  return state.site.item ? state.site.item.brands.reduce((map, brand) => {
    map[brand.brandId] = brand.name;
    return map;
  }, {} as _.Dictionary<string>) : {};
};
